'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorMessage = undefined;
exports.default = ensureChildrenIsValid;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorMessage = exports.errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      _react2.default.Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}